/**
 * UserConstants — kullanıcı/ilişki alanındaki merkezi enum'lar. Kaynak
 * `packages/constants/src/UserConstants.ts` paritesi, TEBHOS profile-Scylla
 * süperküme kararına göre YALNIZCA gerçekten kullanılan alanlar taşınır.
 *
 * ⚠️ RelationshipTypes TEBHOS'ta Kaynak'la BİREBİR AYNI sayısal değerlerle
 * (FRIEND:1, BLOCKED:2, INCOMING_REQUEST:3, OUTGOING_REQUEST:4) zaten VARDI —
 * ama merkezi değil, feature-local `features/relationship/state/
 * RelationshipStore.ts` içindeydi. Tanım buraya TAŞINDI; RelationshipStore.ts
 * artık buradan re-export eder (mevcut import path'leri kırılmaz).
 *
 * NOT (defer): UserFlags/PremiumFlags/ThemeTypes/ProfilePrivacyLevels gibi
 * ek Kaynak enum'ları TEBHOS profil süperkümesinin DIŞINDA (badge/frame/boost
 * yok) — RelationshipTypes kök taşımasının parçası değiller, bu faza
 * alınmadılar.
 */

/** İlişki tipi (backend `relation_type`, sayısal). Discord/Kaynak paritesi. */
export type RelationshipType = 1 | 2 | 3 | 4;

/**
 * Discord-spec relationship tipleri (backend Migration 0055 ile birebir):
 *   1 = FRIEND
 *   2 = BLOCKED
 *   3 = INCOMING_REQUEST (target → user yönünde gelen istek)
 *   4 = OUTGOING_REQUEST (user → target yönünde gönderilen istek)
 */
export const RelationshipTypes = {
  FRIEND: 1 as RelationshipType,
  BLOCKED: 2 as RelationshipType,
  INCOMING_REQUEST: 3 as RelationshipType,
  OUTGOING_REQUEST: 4 as RelationshipType,
} as const;
